module.exports = __webpack_public_path__ + "img/shape_oval_l.93f247e1.svg";